<!--
 * @Author:
 * @Description:
 * @Date: 2025-01-13 10:25:23
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/components/headerNav/index.vue
-->
<!-- logo组件 -->
<template>
  <div class="orderSummary">
    <div class="brandLogo">
      <template v-if="showLogo">
        <template v-if="app.brandInfo && !app.brandInfo.init">
          <img class="logo" v-if="app.brandInfo.logoImage" :src="app.brandInfo.logoImage" />
          <span class="brand" v-else-if="app.brandInfo.brand">{{ getBrandText(app.brandInfo.brand) }}</span>
          <span class="brand" v-else>{{ getWebsiteText(app.brandInfo.website) }}</span>
        </template>
      </template>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { subCharByLength } from '@/utils/tools/utils';
export default {
  name: 'headerNav',
  props: {
  },
  computed: {
    showLogo() {
      return this.$route.meta.showLogo === undefined ? true : this.$route.meta.showLogo;
    },
    ...mapGetters(['app']),
  },
  data() {
    return {
    };
  },
  methods: {
    getBrandText(brand) {
      return subCharByLength(brand, 30);
    },
    getWebsiteText(website) {
      if (!website) {
        return '';
      }
      let w = website.replace('https://', '').replace('http://', '');
      if (w.startsWith('www.')) {
        w = w.replace('www.', '');
      }
      return subCharByLength(w, 30);
    },

  },
};
</script>
<style lang="scss" scoped>
.brandLogo {
  text-align: center;
  padding: 4px;

  box-sizing: border-box;

  img {
    //  width: 60px;
    height: 40px;
    vertical-align: middle;
  }
}

// 111</style>
